var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 37.4993C8.33203 35.2892 9.21 33.1696 10.7728 31.6068C12.3356 30.044 14.4552 29.166 16.6654 29.166H33.332C35.5422 29.166 37.6618 30.044 39.2246 31.6068C40.7874 33.1696 41.6654 35.2892 41.6654 37.4993C41.6654 38.6044 41.2264 39.6642 40.445 40.4456C39.6636 41.227 38.6038 41.666 37.4987 41.666H12.4987C11.3936 41.666 10.3338 41.227 9.55242 40.4456C8.77102 39.6642 8.33203 38.6044 8.33203 37.4993Z",
    stroke: "#F4C135",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.833C28.4518 20.833 31.25 18.0348 31.25 14.583C31.25 11.1312 28.4518 8.33301 25 8.33301C21.5482 8.33301 18.75 11.1312 18.75 14.583C18.75 18.0348 21.5482 20.833 25 20.833Z",
    stroke: "#E98432",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHire);
export default __webpack_public_path__ + "static/media/Hire.ed922d1570dedd08c46bd1b40033f816.svg";
export { ForwardRef as ReactComponent };